export default __webpack_public_path__ + "static/properties/20250702-214123.657/launcher_zh_TW.properties";